import type { RootState } from '../../../store';

export const selectProjectState = (state: RootState) => state.project;
export const selectProjects = (state: RootState) => state.project.projects;
export const selectProjectsStatus = (state: RootState) => state.project.status;
export const selectGetProjectStatus = (state: RootState) => state.project.getProjectStatus;
export const selectUpdateProjectStatus = (state: RootState) => state.project.updateProjectStatus;
export const selectSelectedProject = (state: RootState) => state.project.selectedProject;

export const selectPosts = (state: RootState) => state.project.posts;
export const selectSearchPostsStatus = (state: RootState) => state.project.searchPostsStatus;
export const selectCreatePostStatus = (state: RootState) => state.project.createPostStatus;
export const selectUpdatePostStatus = (state: RootState) => state.project.updatePostStatus;
export const selectDeletePostStatus = (state: RootState) => state.project.deletePostStatus;


